// libs
import React from 'react';
import PropTypes from 'prop-types';
// shared
import { LocaleString } from '@biw/intl';
import * as constants from '@biw/contests-constants';

const PayoutBonusMessage = ( { bonusPayoutStructureType, bonusReplaceOptions, bonusMessage } ) => {
    if ( bonusPayoutStructureType === constants.PT__FIXED ) {
        return <LocaleString code="common.bonus.fixedLabelText" replaceOptions={ bonusReplaceOptions } />;
    } else {
        return <p dangerouslySetInnerHTML={ { __html: bonusMessage } } />;
    }
};

PayoutBonusMessage.propTypes = {
	bonusPayoutStructureType: PropTypes.string.isRequired,
	bonusReplaceOptions: PropTypes.object,
	bonusMessage: PropTypes.string
};

export default PayoutBonusMessage;
